// extracted by mini-css-extract-plugin
module.exports = {"form":"v_9","standalone":"v_bb","error":"v_bc","message":"v_bd"};